<template>
  <div class="leveled">     
      
    <div id="componentBox2" ref="componentBox">
      <div class="mark">Praktisch.vue</div>

      <div id="mat" class="container relative">
        <div class="row relative">
          <div class="col col-1 no-pad relative">            
           
            <div class="nav-side material"  v-bind:style="getHeightOfApp">
              
            </div>

              
          </div>
        
        <div class="col col-11 no-pad">

          <h1>Lesmateriaal praktisch</h1>

          <!-- les 1 -->
          <div id="les1" class="card-deck"
            @mouseover="hoverLesOne = true"
            @mouseleave="hoverLesOne = false">
            <div :class="{ active: hoverLesOne }"class="knob-les">
                <h4 class="les-num-knob">Les 1</h4>
            </div>
            <div class="card" v-if="materiaal.acf.mat_type.includes('praktisch') && materiaal.acf.mat_les==1" v-for="materiaal in orderBy(materiaals,'acf.mat_order')">
              <div class="card-body vid" v-if="materiaal.acf.mat_video">
              <iframe
                    :src="'https://player.vimeo.com/video/' + materiaal.acf.mat_video"
                    width="299"
                    height="198"
                    frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowfullscreen
                ></iframe>

                  <h5 class="card-title">{{ materiaal.title.rendered }}</h5>
              </div>              
              <div class="card-top-img" v-if="!materiaal.acf.mat_video" v-show="materiaal.acf.mat_image" :style="{ 'background-image': 'url(' + materiaal.acf.mat_image + ')' }"></div>
              <div class="card-body" v-show="!materiaal.acf.mat_video">                    
                <div >
                  <h5 class="card-title">{{ materiaal.title.rendered }}</h5>
                  <p class="card-text" v-show="materiaal.acf.mat_text">{{ materiaal.acf.mat_text }}</p>
                </div>                
              </div>
              <div class="card-footer">
                  <a v-if="!materiaal.acf.mat_pdf" v-show="materiaal.acf.mat_btn" target="_blank" class="round-btn-yel" :href="materiaal.acf.mat_btn"></a>
                  <a v-if="materiaal.acf.mat_pdf" v-show="materiaal.acf.mat_pdf" target="_blank" class="round-btn-yel" :href="materiaal.acf.mat_pdf.url"></a> 
                </div>
            </div>
          </div>


          
          <!-- les 2 -->
          <div id="les2" class="card-deck"
          @mouseover="hoverLesTwo = true"
            @mouseleave="hoverLesTwo = false">
            <div class="knob-les" :class="{ active: hoverLesTwo }">
                <h4 class="les-num-knob">Les 2</h4>
            </div>
            <div class="card" v-if="materiaal.acf.mat_type.includes('praktisch') && materiaal.acf.mat_les==2" v-for="materiaal in orderBy(materiaals,'acf.mat_order')">
              <div class="card-body vid" v-if="materiaal.acf.mat_video">
                <iframe
                    :src="'https://player.vimeo.com/video/' + materiaal.acf.mat_video"
                    width="299"
                    height="198"
                    frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowfullscreen
                ></iframe>
                  <h5 class="card-title">{{ materiaal.title.rendered }}</h5>
              </div>              
              <div class="card-top-img" v-if="!materiaal.acf.mat_video" v-show="materiaal.acf.mat_image" :style="{ 'background-image': 'url(' + materiaal.acf.mat_image + ')' }"></div>
              <div class="card-body" v-show="!materiaal.acf.mat_video">                    
                <div >
                  <h5 class="card-title">{{ materiaal.title.rendered }}</h5>
                  <p class="card-text" v-show="materiaal.acf.mat_text">{{ materiaal.acf.mat_text }}</p>
                </div>                
              </div>
              <div class="card-footer">
                  <a v-if="!materiaal.acf.mat_pdf" v-show="materiaal.acf.mat_btn" target="_blank" class="round-btn-yel" :href="materiaal.acf.mat_btn"></a>
                  <a v-if="materiaal.acf.mat_pdf" v-show="materiaal.acf.mat_pdf" target="_blank" class="round-btn-yel" :href="materiaal.acf.mat_pdf.url"></a> 
                </div>
            </div>
          </div>



          <!-- les 3 -->
          <div id="les3" class="card-deck"
          @mouseover="hoverLesThree = true"
            @mouseleave="hoverLesThree = false">
            <div class="knob-les" :class="{ active: hoverLesThree }">
                <h4 class="les-num-knob">Les 3</h4>
            </div>
            <div class="card" v-if="materiaal.acf.mat_type.includes('praktisch') && materiaal.acf.mat_les==3" v-for="materiaal in orderBy(materiaals,'acf.mat_order')">
            
            <div class="card-body vid" v-if="materiaal.acf.mat_video">
                <iframe
                    :src="'https://player.vimeo.com/video/' + materiaal.acf.mat_video"
                    width="299"
                    height="198"
                    frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowfullscreen
                ></iframe>
                <h5 class="card-title">{{ materiaal.title.rendered }}</h5>
            </div>


              



              <div class="card-top-img" v-if="!materiaal.acf.mat_video" v-show="materiaal.acf.mat_image" :style="{ 'background-image': 'url(' + materiaal.acf.mat_image + ')' }"></div>
              <div class="card-body" v-show="!materiaal.acf.mat_video">                    
                <div >
                  <h5 class="card-title">{{ materiaal.title.rendered }}</h5>
                  <p class="card-text" v-show="materiaal.acf.mat_text">{{ materiaal.acf.mat_text }}</p>
                </div>                
              </div>
              <div class="card-footer">
                  <a v-if="!materiaal.acf.mat_pdf" v-show="materiaal.acf.mat_btn" target="_blank" class="round-btn-yel" :href="materiaal.acf.mat_btn"></a>
                  <a v-if="materiaal.acf.mat_pdf" v-show="materiaal.acf.mat_pdf" target="_blank" class="round-btn-yel" :href="materiaal.acf.mat_pdf.url"></a> 
                </div>
            </div>
          </div>




          <!-- les 4 -->
          <div id="les4" class="card-deck"
          @mouseover="hoverLesFour = true"
            @mouseleave="hoverLesFour = false">
            <div class="knob-les" :class="{ active: hoverLesFour }">
                <h4 class="les-num-knob">Les 4</h4>
            </div>
            <div class="card" v-if="materiaal.acf.mat_type.includes('praktisch') && materiaal.acf.mat_les==4" v-for="materiaal in orderBy(materiaals,'acf.mat_order')">
              <div class="card-body vid" v-if="materiaal.acf.mat_video">
                <iframe
                    :src="'https://player.vimeo.com/video/' + materiaal.acf.mat_video"
                    width="299"
                    height="198"
                    frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowfullscreen
                ></iframe>
                  <h5 class="card-title">{{ materiaal.title.rendered }}</h5>
              </div>              
              <div class="card-top-img" v-if="!materiaal.acf.mat_video" v-show="materiaal.acf.mat_image" :style="{ 'background-image': 'url(' + materiaal.acf.mat_image + ')' }"></div>
              <div class="card-body" v-show="!materiaal.acf.mat_video">                    
                <div >
                  <h5 class="card-title">{{ materiaal.title.rendered }}</h5>
                  <p class="card-text" v-show="materiaal.acf.mat_text">{{ materiaal.acf.mat_text }}</p>
                </div>                
              </div>
              <div class="card-footer">
                  <a v-if="!materiaal.acf.mat_pdf" v-show="materiaal.acf.mat_btn" target="_blank" class="round-btn-yel" :href="materiaal.acf.mat_btn"></a>
                  <a v-if="materiaal.acf.mat_pdf" v-show="materiaal.acf.mat_pdf" target="_blank" class="round-btn-yel" :href="materiaal.acf.mat_pdf.url"></a> 
                </div>
            </div>
          </div>







        </div>
      </div>
      </div>

    </div>        
  </div>
</template>


<script>
  import Vue from 'vue'
  import Vue2Filters from 'vue2-filters'
  Vue.use(Vue2Filters)
  import vueVimeoPlayer from 'vue-vimeo-player'
  Vue.use(vueVimeoPlayer)

   export default {
       mixins: [Vue2Filters.mixin],
        name: 'praktisch',
        props:['id'],    

        data: function () {
            return {
              getHeightOfApp: { },
              materiaal:'',
              materiaals:[],
              options: {responsive: true},
              playerReady: false,
              hoverLesOne: true,
              hoverLesTwo: false,
              hoverLesThree: false,
              hoverLesFour: false,
              



            }
        },

        components: { vueVimeoPlayer },
        //components: { 'vimeo-player': vueVimeoPlayer },

        created() {
            this.fetchMat();        
        },

        mounted () {
          this.$nextTick(() => {
            //  ¯\_(ツ)_/¯
            this.matchHeight();
           
          });
         
        },

        //////////////// ツ
    
        methods: {      
      
          matchHeight () {          
            var heightString = $('#componentBox2').height();
            $('.nav-side').height(heightString-500);  
          },

          fetchMat() {
            var self = this;
            this.axios.get(Vue.prototype.$hostname + "/wp/wp-json/wp/v2/materiaals/?per_page=100")
                .then(response => {
                    this.materiaals = response.data;
                   // console.log('Data materials:', response.data);

                  
                    
                    setTimeout(() => {
                        this.matchHeight();

                        if (self.$route.query.goto) {
                            const elToScr = document.getElementById(self.$route.query.goto);
                            self.$scrollTo(elToScr, 1000, { easing: 'ease-out', offset: -20 });
                        }
                    }, 1000);
                    

                })
                .catch(error => {
                    console.error('Error fetching materials:', error);
                });
        },






         


          onReady() {
            this.playerReady = true
          },
          play () {
            this.$refs.player.play()
          },
          pause () {
            this.$refs.player.pause()
          },

          







        }
      }
</script>

<style lang="scss">
.vimeo {
  left: 0;
  top: 0;
  height: 198px;
  width: 299px;
  position: relative;
}
</style> 